import {
  GET_STORY,
  GET_STORY_SUCCESS,
  GET_STORY_UPDATE,
  GET_STORY_ERROR,
  GET_STORIES_STREAM,
  GET_STORIES_STREAM_SUCCESS,
  GET_STORIES_STREAM_UPDATE,
  GET_STORIES_STREAM_ERROR,
  RESET_STORIES_STREAM_ERROR,
  SET_STORY_STREAM,
} from "../constants/actionTypes";

const initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STORY:{
      return {
        ...state,
        isLoading: false,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_STORIES_STREAM: {
      return {
        ...state,
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_STORY_UPDATE: {
      const data = { ...action.payload, slideIn: !!action.position };
      let results = [...state.results];

      // If story is already in stream, remove it
      const exists = results.findIndex((element) => element.id === action.payload.id);
      if (exists >= 0) {
        results.splice(exists, 1);
      }

      // Find index of parent story
      const index = results.findIndex((element) => element.id === action.position);

      // Insert story after parent story
      results.splice(index + 1, 0, data);

      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results,
      };
    }

    case GET_STORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results: [action.payload],
      };

    case GET_STORIES_STREAM_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results: action.payload,
      };
    }

    case GET_STORIES_STREAM_UPDATE: {
      let results = [...state.results];
      let existingStories = state.results.map((story) => story.id);
      action.payload.forEach((story) => {
        if (!existingStories.includes(story.id)) {
          results.push(story);
        }
      });
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results,
      };
    }

    case GET_STORY_ERROR:
    case GET_STORIES_STREAM_ERROR: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };
    }

    case RESET_STORIES_STREAM_ERROR: {
      return {
        ...state,
        isError: false,
        error: null,
      };
    }

    case SET_STORY_STREAM: {
      return {
        ...state,
        results: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
